import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import { noDefault } from 'lib/eventWrappers';
import { ValidationWatcher } from 'lib/validationWatcher';

import { DispatchEvent } from 'data/models/DispatchEvent';

import { LocalizationContext } from 'common/models/LocalizationContext';

import { DispatchEventDetails } from './dispatcheventdetails';

// import { BillExportSettingsView } from 'portcall/billexportsettings/view';
import { DateTimePicker } from 'portcall/datetimepicker/view';
import { PCDismissible } from 'portcall/pcdismissible/view';
import { ToggleButton } from 'portcall/togglebutton/view';
import { ValidationErrorView } from 'core/validationerror/view';

export const DispatchEventDetailsBody = SuperCritical(({ event, canEdit, validation, localization } : {
    event : DispatchEvent,
    canEdit : () => boolean,
    validation : ValidationWatcher,
    localization : LocalizationContext
}) =>
    <div className="dispatch-evt-details-body">
        <div className="dispatch-evt-start">
            <span className="dispatch-evt-field-label pc-text-label-color">Start</span>
            <DateTimePicker
                value={event.Start}
                disabled={!canEdit()}
                localization={localization}
            />
        </div>
        <div className="dispatch-evt-descr">
            <span className="dispatch-evt-field-label pc-text-label-color">Description</span>
            <div className="dispatch-evt-descr-content">
                {canEdit() ?
                    <textarea className="descr-edit-mode"
                        value={event.Description()}
                        onChange={e => event.Description(e.currentTarget.value)} /> :
                    <div className="descr-view-mode">{event.Description()}</div>
                }
                <ValidationErrorView error={() => validation()['Description']} />
            </div>
        </div>
    </div>
);

export const DispatchEventDetailsView = SuperCritical(({ modelContainer } : { modelContainer : () => DispatchEventDetails | null }) => {
    const m = modelContainer();
    if (!m) return null;
    return (
        <div className="dispatcheventdetails pc-card">
            <div className="details-content">
                <div className="details-header pc-card-header">
                    <div className="dispatch-evt-actions-container">
                        {m.CanEdit() &&
                            <button className="dispatch-evt-actions-menu-btn fa fa-bars"
                                onClick={m.ToggleActionsMenu} />
                        }
                        {m.ShowActionsMenu() && 
                            <PCDismissible className="dispatch-evt-actions-menu"
                                onDismiss={() => m.ShowActionsMenu(false)}>
                                <div className="dispatch-evt-actions-menu-item">
                                    <a href="" onClick={noDefault(m.ShowDeleteConfirmation)}>Delete Event</a>
                                </div>
                            </PCDismissible>
                        }
                    </div>
                    {m.DeleteConfirmationVisible() &&
                        <div className="dispatch-evt-delete-conf">
                            <span>Are you sure?</span>
                            {' '}
                            <a href="" className="dispatch-evt-delete-conf-yes" onClick={noDefault(m.Model.Delete)}>Yes</a>
                            {' '}
                            <a href="" className="dispatch-evt-delete-conf-no"  onClick={noDefault(() => m.DeleteConfirmationVisible(false))}>No</a>
                        </div>
                    }
                    <div className="details-title pc-card-title">Event</div>
                </div>
                <DispatchEventDetailsBody event={m.Model.Model}
                    canEdit={m.CanEdit}
                    validation={m.Model.Validation}
                    localization={m.Localization} />
                {m.CanManageBills() &&
                    <div>
                        <PublicPrivateView model={m} />
                        {/* <BillExportSettingsView model={m.BillExportSettings} />
                        <BillAttributesView model={m} /> */}
                    </div>
                }
            </div>
        </div>
    );
});

let PublicPrivateView = SuperCritical(({ model : m } : { model: DispatchEventDetails }) =>
    <div className="dispatch-evt-details-body">
        <div className="dispatch-evt-vis">
            <span className="dispatch-evt-field-label pc-text-label-color">Visibility</span>
            <div className="dispatch-evt-vis-content">
                <ToggleButton
                    checked={m.BillExportSettings.DraftModel.Billable}
                    onLabel="Private"
                    offLabel="Public"
                    selectedLabelClassName="billable-toggle-selected-label"
                    disabled={!m.CanManageBills()}
                />
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./apps/pilots/dispatchdashboard/dispatcheventdetailsview.tsx